// Medical aid tax credits for 2025-2026 tax year (identical to 2024-2025)
export const MEDICAL_AID_CREDITS_2025_26 = {
  mainMember: 364,        // R364 per month for main member
  firstDependent: 364,    // R364 per month for first dependent
  additionalDependent: 246 // R246 per month for each additional dependent
};

// Annual amounts (multiply monthly by 12)
export const ANNUAL_MEDICAL_AID_CREDITS_2025_26 = {
  mainMember: MEDICAL_AID_CREDITS_2025_26.mainMember * 12,           // R4,368
  firstDependent: MEDICAL_AID_CREDITS_2025_26.firstDependent * 12,   // R4,368
  additionalDependent: MEDICAL_AID_CREDITS_2025_26.additionalDependent * 12 // R2,952
};